import axios from './axiosInterceptors';

const API_URL = "/api/v1/";

const getOperationTeams = () => {
    return axios.get(API_URL + `operationteam/OperationTeams`)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            console.log("AXIOS ERROR: ", err);
        })
};

const saveOperationTeam = (opTeam) => {
    return axios
        .post(API_URL + "operationteam/SaveOperationTeam", opTeam).then((response) => {
            return response.data;
        });
};
const deleteOperationTeam = (opTeam) => {
    return axios
        .delete(API_URL + `operationteam/DeleteOperationTeam/${opTeam.operationTeamId}`)
        .then((response) => {
            return response.data;
        })
        .catch((err) => console.log("AXIOS ERROR: ", err))
};

const allActions = {
    getOperationTeams,
    deleteOperationTeam,
    saveOperationTeam
};

export default allActions;